import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { initializeGA, trackPageView } from '../../services/analytics';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    initializeGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

export default GoogleAnalytics;
